export default __webpack_public_path__ + "static/media/logo-green.1b1f5bba.png";